export default "__VITE_ASSET__nZOtdg6N__"